import DashboardLayout from "../../components/Common/DashboardLayout";
import ImportUsersComponent from "../../components/ImportUsers";
import useAuthGuard from "../../Hooks/useAuthGuard";
import { FR_ROLE } from "../../utils/constants";

const ImportUsers = () => {
  useAuthGuard({
    allowedRoles: [
      FR_ROLE.FIRST_RESPONDER_ADMIN,
      FR_ROLE.FIRST_RESPONDER_OWNER,
    ],
  });
  return (
    <DashboardLayout page="importUsers">
      <ImportUsersComponent />
    </DashboardLayout>
  );
};

export default ImportUsers;
